import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Martín R.',
  age: 34,
  level: '6ta Categoría',
  text: 'Siempre sentí que jugaba al revés. Aplicar los patrones del Tomo 1 me cambió la cabeza. Ahora mis rivales se calientan porque no saben por dónde entrarme.'
}, {
  name: 'Diego F.',
  age: 28,
  level: '5ta Categoría',
  text: 'La víbora de zurdo explicada en el Tomo 2 vale el precio de todo el sistema. Pasé de defender a atacar con un solo golpe. Una locura.'
}, {
  name: 'Alejandro M.',
  age: 42,
  level: '7ma Categoría',
  text: 'Juego hace poco y no entendía dónde pararme. Los diagramas son re claros. Mi compañero diestro está chocho porque por fin cubro bien el medio.'
}, {
  name: 'Facundo L.',
  age: 31,
  level: '4ta Categoría',
  text: 'El manual anti-zurdo del Tomo 6 me abrió la cabeza. Ahora sé exactamente qué me van a jugar y cómo contrarrestarlo antes de que lo hagan.'
}, {
  name: 'Javier G.',
  age: 39,
  level: '5ta Categoría',
  text: 'Los bonos son una masa. Las 50 jugadas ganadoras las imprimo y las repaso antes de cada torneo. Un material que no conseguís en ningún lado.'
}];
export function Testimonials() {
  return <section className="py-20 px-4 bg-brand-dark" data-id="element-132">
      <div className="max-w-6xl mx-auto" data-id="element-133">
        <div className="text-center mb-16" data-id="element-134">
          <h2 className="font-display text-3xl md:text-5xl text-white uppercase mb-4" data-id="element-135">
            Zurdos que ya están{' '}
            <span className="text-brand-green" data-id="element-136">dominando</span>
          </h2>
          <p className="font-body text-lg text-gray-400" data-id="element-137">
            Jugadores amateur de Argentina que cambiaron su forma de ver la
            cancha.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-138">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-brand-card p-8 rounded-2xl border border-white/5 relative" data-id="element-139">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-brand-green/20" data-id="element-140" />
              <div className="flex gap-1 mb-4" data-id="element-141">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-brand-green text-brand-green" data-id="element-142" />)}
              </div>
              <p className="font-body text-gray-300 mb-6 italic leading-relaxed" data-id="element-143">
                "{test.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-144">
                <div className="w-10 h-10 rounded-full bg-brand-green/10 flex items-center justify-center font-display text-brand-green border border-brand-green/30" data-id="element-145">
                  {test.name.charAt(0)}
                </div>
                <div data-id="element-146">
                  <p className="font-body font-bold text-white" data-id="element-147">{test.name}</p>
                  <p className="font-body text-sm text-gray-500" data-id="element-148">
                    {test.age} años · {test.level}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}